import React, { useState, useEffect } from "react"
import axios from 'axios'

import './CapaProcesso.css'
import brasao from '../../assets/brasilNav.png'

const CapaProcesso = ({ processo, numero }) => {
    // const id = window.location.pathname.slice(23)
    // const [processo, setProcesso] = useState({})

    // useEffect(() => {
    //     axios.post('/api/juridico/getProcesso', { id: id })
    //         .then(res => setProcesso(res.data))
    //         .catch(error => alert(error.response.message))
    // }, [])
    // console.log(processo)
    return (
        <>
            <div className="capaProcessoContainer">
                <header className="capaProcessoHeader">
                    <img src={brasao} alt="Brasil" crossorigin="anonymous" />
                    <p>Serviço Público Federal</p>
                    <p>Conselho Regional de Fisioterapia e Terapia Ocupacional da 1ª Região</p>
                    <p>CREFITO-1</p>
                </header>

                <section className="capaProcessoContent">
                    <p className='capaProcessoBold'>PROCESSO ADMINISTRATIVO</p>
                    <p className='capaProcessoBold'>Nº {numero && numero || '___'}/{processo.dataInstauracao && processo.dataInstauracao.slice(0, 4)}</p>
                </section>

                <section className="capaProcessoDetalhes">
                    <p>Classificação: {processo.tipo && processo.tipo || '___'}</p>
                    <p>Interessados:</p>
                    {processo.interessados && processo.interessados.map(el => {
                        return (
                            <>
                                <p>{el?.nome}</p>
                                <p>{el?.razaoSocial}</p>
                            </>
                        )
                    })}
                </section>

                <section className="capaProcessoFooter">
                    <p>{processo.dataInstauracao && processo.dataInstauracao.slice(0, 4)}</p>
                    <p>RECIFE/PE</p>
                </section>
            </div>
        </>
    )
}

export default CapaProcesso